/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-closing-tag-location */
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import * as moment from 'moment';
import React, { Component } from 'react';
import Swal from 'sweetalert2';
import {
	CommaSeparator,
	GetUtcDate,
	checkIfPastDate,
	convertToLangKey,
	onChangeCommaSeperator
} from '../../../AppUtil/AppUtil';

import validate from '../../../AppUtil/validate';
import LoanService from '../../../Service/LoanService';
import { commonStyleForDetail } from '../../Common/CommonStyle';
import DwollaPlaid from '../../Common/DwollaPlaid';
import DateInput from '../../Common/Inputs/DateInput';
import Input from '../../Common/Inputs/Input';
import InterestSlider from '../../Common/Inputs/InterestSlider';
import MultiLineInput from '../../Common/Inputs/MultiLineInput';
import OutlinedInput from '../../Common/Inputs/OutlinedInput';
import Select from '../../Common/Inputs/Select';
import PaymentMethod from '../../Common/PaymentMethod';
import BaseContainer from './BaseContainer';
import Button from './Button';
import PaperComponent from './PaperComponent';

import { withTranslation } from 'react-i18next';
import {
	toastWhenPaymentMethodBank,
	toastWhenPaymentMethodCash,
	toastWhenPaymentMethodCashPastDate
} from '../../../SweetAlertUtil/util';

const APP_MESSAGE = window.AppMessage;
const LOAN_CONSTANTS = window.AppConfig.LOAN_CONSTANTS;
const PATTERN = window.AppConfig.REGULAR_EXPRESSION;
const LOAN_TYPES = window.AppConfig.LOAN_TYPES;

const reasons = [
	'Business',
	'Medical',
	'Real Estate',
	'Debt',
	'Mortgage',
	'Tuition Fee',
	'Home Improvement',
	'Wedding',
	'Rent',
	'Vacation',
	'Utility',
	'Buy Something',
	'Vehicle',
	'Other',
	'Auto Repair'
];
const reasonsMap = reasons.map(reason => ({
	value: reason,
	label: `${convertToLangKey(reason)}`
}));

let SUPPORTED_FREQUENCY = [];

class ModifyDetails extends Component {
	constructor(props) {
		super(props);
		this.inputLabel = React.createRef();
		this.state = {
			isInterestValid: true,
			_isPaymentMethodScreenOpen: false,
			_modifyButtonDisable: false,
			_isLoading: false,
			labelWidthReason: null,
			_minInterest: 0,
			_maxInterest: 0,
			interest_rate: this.props.loanObject.annual_rate,
			reason: this.props.loanObject.reason,
			otherReason: '',
			principal: this.props.loanObject.principal,
			frequency: this.props.loanObject.frequency,
			no_of_installments: this.props.loanObject.no_of_installments,
			first_installment_date: this.props.loanObject.first_installment_date,
			collateral: this.props.loanObject.collateral || 'None',
			additional_terms: this.props.loanObject.additional_terms || 'None',
			states: this.props.loanObject.lender_state,
			disbursal_date: this.props.loanObject.disbursal_date,
			itemDescription: this.props.loanObject.item_purchased,
			errorPrincipal: '',
			errorInstallment: '',
			_isDwollaPlaidScreenOpen: false,
			_errorItemDescription: '',
			_disableFrequencyOnLumpSum: false,
			_errorFrequency: ''
		};
	}

	handleItemDescriptionChange = e => {
		this.setState({
			_errorItemDescription: '',
			itemDescription: e.target.value
		});
	};

	openPaymentScreen = () => {
		this.setState({
			_isPaymentMethodScreenOpen: true
		});
	};

	closePaymentScreen = () => {
		this.setState({
			_isPaymentMethodScreenOpen: false
		});
	};

	redirectToDwollaPlaid = () => {
		this.setState({
			_isDwollaPlaidScreenOpen: true
		});
	};

	closeDwollaPlaid = () => {
		this.setState({
			_isDwollaPlaidScreenOpen: false
		});
		this.handleModifyLoanRequest();
	};

	onBackDwollaPlaid = () => {
		this.setState({
			_isDwollaPlaidScreenOpen: false
		});
	};

	handleLumpSumFrequency = () => {
		if (this.props.loanObject.frequency === 'LUMP_SUM') {
			this.setState({
				_disableFrequencyOnLumpSum: true,
				frequency: 'LUMP_SUM'
			});
		}
	};

	startLoader = () => {
		this.setState({
			_isLoading: true
		});
	};

	stopLoader = () => {
		this.setState({
			_isLoading: false
		});
	};

	setLabelWidthReason = () => {
		this.setState({
			labelWidthReason: this.inputLabel.current.offsetWidth
		});
	};

	handleReasonChange = e => {
		console.log(e.target.value);
		this.setState({
			reason: e.target.value,
			otherReason: ''
		});
	};

	handlePrincipalChange = e => {
		console.log(e.target.value);
		this.setState({
			errorPrincipal: '',
			principal: onChangeCommaSeperator(e.target.value || '0')
		});
	};

	handleFrequencyChange = e => {
		this.setState({
			frequency: e.target.value,
			_errorFrequency: ''
		});
	};

	handleDateChange = date => {
		this.setState({
			_modifyButtonDisable: false,
			first_installment_date: GetUtcDate(date)
		});
	};

	onMinDateError = e => {
		if (e === APP_MESSAGE.MIN_DATE_MESSAGE || e === APP_MESSAGE.INVALID_DATE_FORMAT) {
			this.setState({
				_modifyButtonDisable: true
			});
		}
	};

	handleNoOfInstallments = e => {
		if (e.target.value === '1') {
			this.setState({
				_disableFrequencyOnLumpSum: true,
				frequency: 'LUMP_SUM'
			});
		}

		if (e.target.value > 1 && this.state.frequency === 'LUMP_SUM') {
			this.setState({
				_disableFrequencyOnLumpSum: false,
				frequency: 'MONTH'
			});
		}

		if (e.target.value > this.checkMaxIns() || e.target.value < 1 || this.checkIsFloatNumber(e.target.value)) {
			this.setState({
				errorInstallment: `Minimum amount per installment is Php 1,000. The number of installments cannot be 0 or more than ${this.checkMaxIns()}.`,
				no_of_installments: e.target.value
			});
		} else {
			this.setState({
				errorInstallment: '',
				no_of_installments: e.target.value
			});
		}
	};

	checkIsFloatNumber(value) {
		var floatValue = parseFloat(value);

		return !isNaN(floatValue) && floatValue.toString() !== value.toString();
	}

	handleCollateralChange = e => {
		this.setState({
			collateral: e.target.value
		});
	};

	handleAdditionalTerms = e => {
		this.setState({
			additional_terms: e.target.value
		});
	};

	handleInterestChange = (_e, interest) => {
		this.setState({
			interest_rate: interest
		});
	};

	handleStateChange = event => {
		this.setState({
			states: event.target.value
		});
		this.setInterestRate(event.target.value);
	};

	setInterestRate = value => {
		// const states = Session.get('STATES');
		this.setState({
			// _maxInterest: parseFloat(states[value].recommended_max_rate),
			// _minInterest: parseFloat(states[value].short_term)
			_maxInterest: parseFloat(6),
			_minInterest: parseFloat(0)
		});
	};

	setDisbursaldate = date => {
		if (moment(date).diff(moment(), 'day') > 0 || moment(date).format() === 'Invalid date') {
			this.setState({
				disbursal_date: GetUtcDate(date),
				_modifyButtonDisable: true
			});
		} else {
			this.setState({
				disbursal_date: GetUtcDate(date),
				_modifyButtonDisable: false
			});
		}
	};

	validFields = () => {
		const amountValidationRules = {
			isRequired: {
				value: true,
				errorMsg: 'error_message.required_amount'
			},
			min: {
				value: LOAN_CONSTANTS.MIN,
				errorMsg: 'error_message.amount_can_not_be_less_than_50'
			},
			max: {
				value: LOAN_CONSTANTS.MAX,
				errorMsg: 'error_message.amount_can_not_be_greater_than_5000'
			},
			pattern: {
				value: PATTERN.NUMBER_WITH_PRECISION_2,
				errorMsg: 'error_message.amount_should_be_precision_two'
			}
		};
		const principal = parseFloat(
			typeof this.state.principal === 'string' ? +this.state.principal.replace(/,/g, '') : this.state.principal
		);

		const instalments = Number(this.state.no_of_installments);
		const MIN_INSTALLMENTS = 1;
		const MAX_INSTALLMENTS = this.checkMaxIns();
		const installmentsValidationRules = {
			isRequired: {
				value: true,
				errorMsg: 'error_message.field_required'
			},
			pattern: {
				value: PATTERN.NUMBER_WITHOUT_DECIMAL,
				errorMsg: 'error_message.decimal_value_not_allowed'
			},
			min: {
				value: MIN_INSTALLMENTS,
				errorMsg: 'error_message.installment_can_not_be_zero'
			},
			max: {
				value: MAX_INSTALLMENTS,
				errorMsg: 'error_message.installment_can_not_be_greater_than_max'
			}
		};
		const itemDescriptionValidation = {
			isRequired: {
				value: true,
				errorMsg: 'error_message.required_amount'
			},
			pattern: {
				value: PATTERN.ACCEPT_300_CHARACTERS,
				errorMsg: 'error_message.item_description_cant_be_more_than_300'
			}
		};
		const [_errorPrincipalIsValid, _errorPrincipal] = validate(principal, amountValidationRules);
		const [_errorInstallmentIsValid, _errorInstallment] = validate(instalments, installmentsValidationRules);
		const [_errorItemDescriptionValid, _errorItemDescription] = validate(
			this.state.itemDescription,
			itemDescriptionValidation
		);
		if (!_errorPrincipalIsValid) {
			this.setState({
				errorPrincipal: _errorPrincipal
			});
			return;
		}
		if (!_errorInstallmentIsValid) {
			this.setState({
				errorInstallment: _errorInstallment
			});
			return;
		}
		if (this.props.loanObject.loan_workflow_id === 3 && !_errorItemDescriptionValid) {
			this.setState({
				_errorItemDescription: _errorItemDescription
			});
			return;
		}
		if (this.state.frequency === '') {
			this.setState({
				_errorFrequency: 'error_message.required_frequency'
			});
			return;
		}
		this.handleModifyLoanRequest();
	};

	toastWhenLoanActionFail = () => {
		Swal.fire({
			title: this.props.t('sweetalert_title.error'),
			text: this.props.t('error_message.your_loan_has_been_canceled'),
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			confirmButtonText: this.props.t('buttons.try_again'),
			customClass: 'otp_message_success'
		});
	};

	toastWhenSomethingWentWrong = errMesssage => {
		Swal.fire({
			title: this.props.t('sweetalert_title.error'),
			text: errMesssage,
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			confirmButtonText: this.props.t('buttons.close'),
			customClass: 'otp_message_success'
		});
	};

	toastLoanAccepted = _loanObject => {
		Swal.fire({
			animation: false,
			text: this.props.t('error_message.loan_modified_lender', { borrower_name: this.props.loanObject.name }),
			title: this.props.t('sweetalert_title.request_submitted'),
			icon: 'success',
			confirmButtonText: this.props.t('buttons.continue'),
			customClass: 'otp_message_success'
		});
	};

	handleModifyLoanRequest = () => {
		const loan = this.props.loanObject;
		const wallet = this.props.currentUser.profile.wallet_connected || false;
		if (!wallet) {
			this.redirectToDwollaPlaid();
			return false;
		} else if (!loan.disbursal_mode && (loan.loan_workflow_id === 1 || loan.loan_workflow_id === 0)) {
			if (
				(loan.created_by === this.props.currentUserId && loan.loan_type === LOAN_TYPES.LEND) ||
				(loan.created_by !== this.props.currentUserId && loan.loan_type === LOAN_TYPES.BORROW)
			) {
				this.openPaymentScreen();
				return false;
			}
		}
		this.onModify();
	};

	handlePaymentMethodCallback = payment => {
		if (payment) {
			if (payment.payment_mode === 'ACH') {
				toastWhenPaymentMethodBank(this.props.loanObject.name, payment, this.onModify, this.closePaymentScreen);
			} else {
				if (moment(payment.payment_date).diff(moment(), 'day') < 0) {
					toastWhenPaymentMethodCashPastDate(payment, this.onModify, this.closePaymentScreen);
				} else {
					toastWhenPaymentMethodCash(
						this.props.loanObject.name,
						payment,
						this.onModify,
						this.closePaymentScreen
					);
				}
			}
		}
	};

	onModify = async payment => {
		this.startLoader();
		try {
			const requestBody = {
				start_date: this.props.loanObject.start_date,
				first_installment_date: this.state.first_installment_date,
				no_of_installments: parseInt(this.state.no_of_installments),
				annual_rate: parseFloat(this.state.interest_rate),
				frequency: this.state.frequency,
				principal: parseFloat(
					typeof this.state.principal === 'string'
						? +this.state.principal.replace(/,/g, '')
						: this.state.principal
				),
				reason: this.state.otherReason || this.state.reason,
				additional_terms: this.state.additional_terms === 'None' ? '' : this.state.additional_terms,
				lender_state: this.state.states,
				collateral: this.state.collateral === 'None' ? '' : this.state.collateral
			};
			if (payment) {
				requestBody.disbursal_mode = payment.payment_mode;
				if (payment.payment_mode === 'OFFLINE') {
					requestBody.disbursal_date = GetUtcDate(payment.payment_date);
				} else {
					requestBody.disbursal_date = new Date().toISOString();
				}
			} else if (this.props.loanObject.loan_workflow_id === 2) {
				requestBody.disbursal_date = GetUtcDate(this.state.disbursal_date);
			} else if (this.props.loanObject.loan_workflow_id === 3) {
				requestBody.disbursal_date = GetUtcDate(this.state.disbursal_date);
				requestBody.item_purchased = this.state.itemDescription;
			}
			const response = await LoanService.create(`loan/${this.props.loanObject.id}/modify`, requestBody);
			this.stopLoader();
			if (!response.status) {
				if (response.data === "You can't modify loan at this state") {
					this.toastWhenLoanActionFail();
					this.props.closeModifyFlow();
					this.props.closeLoanDetail();
				} else {
					this.toastWhenSomethingWentWrong(response.data);
				}
			} else {
				this.toastLoanAccepted(this.props.loanObject);
				this.props.closeModifyFlow();
			}
		} catch (err) {
			console.log(err);
			this.stopLoader();
		}
	};

	setDefaultValue = () => {
		const loanObject = this.props.loanObject;
		// const states = Session.get('STATES');
		this.setState({
			// _maxInterest: parseFloat(states[loanObject.lender_state].recommended_max_rate),
			// _minInterest: parseFloat(states[loanObject.lender_state].short_term)
			_maxInterest: parseFloat(6),
			_minInterest: parseFloat(0)
		});
	};

	handleLumpSumWhenInstallmentIsOne = () => {
		SUPPORTED_FREQUENCY = this.props.supportedFrequency.map(frequency => {
			if (frequency.value !== 'LUMP_SUM') {
				return {
					label: frequency.label,
					value: frequency.value
				};
			}
		});
	};

	componentDidMount() {
		this.handleLumpSumWhenInstallmentIsOne();
		this.setDefaultValue();
		this.handleLumpSumFrequency();
		if (this.props.loanObject.loan_workflow_id !== 3) {
			this.setLabelWidthReason();
		}

		if (reasons.indexOf(this.props.loanObject.reason) === -1) {
			this.setState({
				reason: 'Other',
				otherReason: this.props.loanObject.reason
			});
		}
	}

	checkMaxIns() {
		const principal = parseFloat(
			typeof this.state.principal === 'string' ? +this.state.principal.replace(/,/g, '') : this.state.principal
		);

		return Math.floor(principal / LOAN_CONSTANTS.MIN);
	}

	render() {
		// NOSONAR
		const { t, classes } = this.props;
		const FILTERED_SUPPORTED_FREQUENCY = SUPPORTED_FREQUENCY?.filter(function (element) {
			return element !== undefined;
		});

		if (this.state._isPaymentMethodScreenOpen) {
			return (
				<PaymentMethod
					handleBack={this.closePaymentScreen}
					handleContinue={this.handlePaymentMethodCallback}
					maxPaymentDate={this.state.first_installment_date}
				/>
			);
		} else if (this.state._isDwollaPlaidScreenOpen) {
			return (
				<DwollaPlaid
					currentUser={this.props.currentUser}
					onBack={this.onBackDwollaPlaid}
					onClose={this.closeDwollaPlaid}
					openScreen={this.props.openScreen}
					setCurrentUser={this.props.setCurrentUser}
					supportedStates={this.props.supportedStates}
				/>
			);
		} else {
			return (
				<BaseContainer className={classes.root} isLoading={this.state._isLoading}>
					<PaperComponent>
						{this.props.loanObject.loan_workflow_id === 3 ? (
							<MultiLineInput
								error={(() => {
									return this.state._errorItemDescription ? t(this.state._errorItemDescription) : '';
								})()}
								label={t('label.describe_the_item')}
								onChange={this.handleItemDescriptionChange}
								value={this.state.itemDescription}
							/>
						) : (
							<div style={{ display: 'flex', flexDirection: 'column', rowGap: '15px' }}>
								<Select
									inputLabel={this.inputLabel}
									label={t('label.loan_purpose')}
									labelWidth={this.state.labelWidthReason}
									onChange={this.handleReasonChange}
									options={reasonsMap}
									translate
									value={this.state.reason}
								/>

								{this.state.reason === 'Other' && (
									<Input
										label="Enter Other Loan Purpose"
										value={this.state.otherReason}
										onChange={e =>
											this.setState({
												otherReason: e.target.value
											})
										}
									/>
								)}
							</div>
						)}
					</PaperComponent>
					<PaperComponent>
						<OutlinedInput
							className={classes.margin}
							valueClassName="bold-important"
							disabled={this.props.loanObject.state === 'APPROVE'}
							error={this.state.errorPrincipal ? t(this.state.errorPrincipal) : ''}
							id="outlined-adornment-amount"
							label={t('label.amount')}
							labelWidth={60}
							onChange={this.handlePrincipalChange}
							startAdornment={<InputAdornment position="start">₱</InputAdornment>}
							type="text"
							value={this.state.principal ? CommaSeparator(this.state.principal) : ''}
						/>
					</PaperComponent>
					<PaperComponent>
						<DateInput
							label={t('label.first_payment_date')}
							minDate={(() => {
								if (this.props.loanObject.disbursal_date) {
									if (checkIfPastDate(this.props.loanObject.disbursal_date)) {
										return new Date();
									} else {
										return moment(this.props.loanObject.disbursal_date).toDate();
									}
								} else {
									return new Date();
								}
							})()}
							minDateMessage={t('error_message.min_date_message')}
							onChange={this.handleDateChange}
							onError={this.onMinDateError}
							value={this.state.first_installment_date}
						/>
					</PaperComponent>
					{this.props.loanObject.loan_workflow_id === 2 || this.props.loanObject.loan_workflow_id === 3 ? (
						<PaperComponent>
							<DateInput
								label={t('label.loan_funded_date')}
								maxDate={new Date()}
								maxDateMessage={t('error_message.date_cant_be_of_future')}
								onChange={this.setDisbursaldate}
								// onError={this.onMinDateError}
								value={this.state.disbursal_date}
							/>
						</PaperComponent>
					) : null}
					<PaperComponent>
						<Input
							label={t('label.collateral')}
							onChange={this.handleCollateralChange}
							value={this.state.collateral}
						/>
					</PaperComponent>
					<PaperComponent>
						<Select
							error={this.state.isEmpty}
							label={t('label.state')}
							labelWidth={40}
							onChange={state => {
								this.handleStateChange(state);
							}}
							options={this.props.supportedStates}
							value={this.state.states}
						/>
					</PaperComponent>
					<PaperComponent>
						<InterestSlider
							label={t('label.interest_rate')}
							max={this.state._maxInterest}
							min={this.state._minInterest}
							onChange={this.handleInterestChange}
							value={this.state.interest_rate}
						/>

						{console.log(this.state.interest_rate)}
						<div style={{ display: 'flex', justifyContent: 'center', marginTop: '-20px' }}>
							<input
								type="number"
								className="custom-input"
								value={this.state.interest_rate}
								onChange={e => {
									const regex = /^\d+(\.\d{0,2})?$/;
									const inputValue = e.target.value;
									if (!regex.test(inputValue)) {
										return; // Exit the function if invalid
									}

									const currentValue = +inputValue; // Convert input to number

									const allowedValues = [
										0.0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65,
										0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1.0, 1.05, 1.1, 1.15, 1.2, 1.25, 1.3, 1.35,
										1.4, 1.45, 1.5, 1.55, 1.6, 1.65, 1.7, 1.75, 1.8, 1.85, 1.9, 1.95, 2.0, 2.05,
										2.1, 2.15, 2.2, 2.25, 2.3, 2.35, 2.4, 2.45, 2.5, 2.55, 2.6, 2.65, 2.7, 2.75,
										2.8, 2.85, 2.9, 2.95, 3.0, 3.05, 3.1, 3.15, 3.2, 3.25, 3.3, 3.35, 3.4, 3.45,
										3.5, 3.55, 3.6, 3.65, 3.7, 3.75, 3.8, 3.85, 3.9, 3.95, 4.0, 4.05, 4.1, 4.15,
										4.2, 4.25, 4.3, 4.35, 4.4, 4.45, 4.5, 4.55, 4.6, 4.65, 4.7, 4.75, 4.8, 4.85,
										4.9, 4.95, 5.0, 5.05, 5.1, 5.15, 5.2, 5.25, 5.3, 5.35, 5.4, 5.45, 5.5, 5.55,
										5.6, 5.65, 5.7, 5.75, 5.8, 5.85, 5.9, 5.95, 6.0
									];

									this.setState({
										isInterestValid: true
									});
									// Check if currentValue is in the allowedValues array
									if (!allowedValues.includes(currentValue)) {
										this.setState({
											interest_rate: 0,
											isInterestValid: false
										});
										return;
									}

									this.setState({
										interest_rate: currentValue
									});
								}}
							/>{' '}
							&#37;
						</div>
						{!this.state.isInterestValid && (
							<p style={{ color: '#f44336', textAlign: 'center', marginTop: '10px' }}>
								Please enter a value between 0 and 6 with an interval of 0.05
							</p>
						)}
					</PaperComponent>
					<PaperComponent>
						<Select
							error={t(this.state._errorFrequency)}
							isDisabled={this.state._disableFrequencyOnLumpSum}
							label={t('label.frequency')}
							labelWidth={70}
							onChange={this.handleFrequencyChange}
							options={
								this.state.no_of_installments > 1
									? FILTERED_SUPPORTED_FREQUENCY
									: this.props.supportedFrequency
							}
							translate
							value={this.state.frequency}
						/>
					</PaperComponent>
					<PaperComponent>
						<Input
							className="bold-important"
							error={
								this.state.errorInstallment
									? t(this.state.errorInstallment, { max_installments: this.checkMaxIns() })
									: ''
							}
							label={t('label.number_of_installments')}
							onChange={this.handleNoOfInstallments}
							type="number"
							value={this.state.no_of_installments || ''}
						/>
					</PaperComponent>
					<PaperComponent>
						<Input
							label={t('label.additional_terms_and_conditions')}
							onChange={this.handleAdditionalTerms}
							value={this.state.additional_terms || ''}
						/>
					</PaperComponent>
					<Button
						className={`${classes.submit} back-loan-modify-btn`}
						id="back-btn"
						onClick={this.props.closeModifyFlow}
						type="submit">
						{t('buttons.back')}
					</Button>

					<Button
						className="save-and-modify-btn"
						aria-label="add"
						disabled={this.state._modifyButtonDisable}
						fullWidth
						id={this.state._modifyButtonDisable ? 'disabled-button' : 'save-loan-modify-btn'}
						onClick={this.validFields}>
						{t('buttons.save_and_modify')}
					</Button>
				</BaseContainer>
			);
		}
	}
}

export default withTranslation()(withStyles(commonStyleForDetail)(ModifyDetails));
